import { Injectable } from '@angular/core';
import { CommonHeaderService } from './common-header.service';
import { Configuration, API_ENDPOINT } from '@app/config';

@Injectable()
export class PrebidClient {

    config: any = [];

    constructor(public commonHeaderService: CommonHeaderService) {
        this.config[API_ENDPOINT] = Configuration.PREBID_ENDPOINT;
    }

    getDefaultHeader() {
        let headers = this.commonHeaderService.getDefaultHeaderRequestParams();
        headers = headers.delete('timezone');
        return headers;
    }

    getApiEndpoint() {
        return this.config[API_ENDPOINT];
    }
}



// WEBPACK FOOTER //
// ./src/app/common/http-client/prebid-client.ts